import { renderToStaticMarkup } from "react-dom/server";
import ConditionalFormattingIcon from "components/svg-icons/conditional-formatting-icon";

/** Set on the header cell by `defaultColDef.headerClass`; reveals the icon. */
export const CONDITIONAL_FORMATTING_APPLIED_HEADER_CLASS =
  "ciq-conditional-formatting-applied";

export const CONDITIONAL_FORMATTING_HEADER_ICON_CLASS =
  "ciq-conditional-formatting-header-icon";

/**
 * Rendered into AG Grid header templates as raw markup, so it must stay a
 * string rather than a React node. Display-only indicator after the filter icon.
 */
export const CONDITIONAL_FORMATTING_HEADER_ICON = `<span class="${CONDITIONAL_FORMATTING_HEADER_ICON_CLASS}" aria-hidden="true" title="Conditional formatting">${renderToStaticMarkup(
  <ConditionalFormattingIcon />
)}</span>`;

/**
 * Same structure as AG Grid's built-in header, with sort before filter so the
 * applied icons read: sort, filter, then the CF icon. The `eSort*` refs are
 * the documented stand-in for `<ag-sort-indicator>` in custom templates.
 */
export const conditionalFormattingHeaderTemplate = () => ({
  template: `<div class="ag-cell-label-container" role="presentation">
        <span data-ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
        <span data-ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
        <div data-ref="eLabel" class="ag-header-cell-label" role="presentation">
          <span data-ref="eText" class="ag-header-cell-text"></span>
          <span class="ag-sort-indicator-container">
            <span data-ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
            <span data-ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
            <span data-ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
            <span data-ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
            <span data-ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
          </span>
          <span data-ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
          ${CONDITIONAL_FORMATTING_HEADER_ICON}
          </div>
      </div>`
});
